import React from 'react'
import parentStyles from '../styles.module.scss'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Spinner from 'srcReact/components/common2/Spinner'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'

export default function Common({
  membersToInvite,
  lastMemberRef,
  search,
  startDirectConversation,
  showUserLightModal,
  isMemberAddedForInvitation
}) {
  const { t } = useTranslation()

  const {
    messenger: {
      searchedMembers,
      loadingInSidebar,
      searchedMemberError,
      search: { list }
    }
  } = useSelector((state) => state)

  // To find 1v1 conversation from member search results
  let find1v1ConversationInMemberSearch = []
  if (search?.length > 2 && list?.length > 0 && searchedMembers?.length > 0) {
    find1v1ConversationInMemberSearch = searchedMembers.filter(
      (member) =>
        !list.some(
          (conv) =>
            conv?.conversation?.is_group_conversation === 0 &&
            conv?.active_users?.some((user) => user.id === member.user_id)
        )
    )
  }

  let filteredMembers = list?.length > 0 ? find1v1ConversationInMemberSearch : searchedMembers

  return (
    <div className={parentStyles.container}>
      {filteredMembers && filteredMembers.length > 0 && (
        <React.Fragment>
          <div className={styles.startNewChatTitle}>{t('messenger.startNewChat')}</div>

          <hr className={styles.divider} />

          <div className={`${parentStyles.list} ${membersToInvite.length > 0 ? styles.listMaxHeight : styles.list}`}>
            {filteredMembers
              .filter((member) => !isMemberAddedForInvitation(membersToInvite, member))
              .map((member, index) => {
                const isLastMember = filteredMembers.length === index + 1

                return (
                  <div
                    key={member.user_id}
                    ref={isLastMember ? lastMemberRef : null}
                    className={`${parentStyles.memberInList} ${styles.memberInList} `}>
                    <div className={parentStyles.memberInListInner}>
                      <Avatar
                        key={'member_' + member.user_id}
                        userId={member.user_id}
                        profilePicture={member.profile_picture_url}
                        firstname={member.firstname}
                        lastname={member.lastname}
                        imgWrapperSize='small'
                        onClickAction={() => showUserLightModal(member)}
                        mimeType={member.mime_type}
                        originalTag={member.original_tag}
                        isOriginal={member.is_original}
                        withExpertiseGroup={member.with_expertise_group}
                      />
                      <button
                        type='button'
                        onClick={() => startDirectConversation(member)}
                        className={parentStyles.addRemoveIconButton}>
                        <div className={parentStyles.userProfile}>
                          <div className={styles.memberName}>
                            {member.firstname} {member.lastname}
                          </div>
                        </div>

                        <div className={styles.startNewChartButton}>
                          <Icon name='write' size='large24' styleModifier={styles.startNewChartIcon} />
                        </div>
                      </button>
                    </div>
                  </div>
                )
              })}
            {loadingInSidebar || (searchedMemberError && searchedMemberError === 'cancelTokenError') ? (
              <Spinner />
            ) : null}
          </div>
          <div className={parentStyles.finalLine}></div>
        </React.Fragment>
      )}
    </div>
  )
}
